import { withSentryReactRouterV6Routing } from '@sentry/react';
import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { routes } from '../../../routes';
import Home from '../Home/Home';
import ManufacturerAccountDetails from '../ManufacturerAccountDetails/ManufacturerAccountDetails';
import ManufacturerAccounts from '../ManufacturerAccounts/ManufacturerAccounts';
import PageNotFound from '../PageNotFound/PageNotFound';
import Settings from '../Settings/Settings';

const AdminRouter: FC = () => {
  const SentryRoutes = withSentryReactRouterV6Routing(Routes);

  return (
    <SentryRoutes>
      <Route path={routes.HOME} element={<Home />} />
      <Route
        path={routes.MANUFACTURER_ACCOUNTS}
        element={<ManufacturerAccounts />}
      />
      <Route
        path={routes.NEW_MANUFACTURER_ACCOUNT}
        element={<ManufacturerAccountDetails />}
      />
      <Route
        path={`${routes.EDIT_MANUFACTURER_ACCOUNT}/:manufacturerId`}
        element={<ManufacturerAccountDetails edit />}
      />
      <Route path={routes.SETTINGS} element={<Settings />} />
      <Route path={routes.PAGE_NOT_FOUND} element={<PageNotFound />} />
      <Route path={'*'} element={<Navigate to={routes.HOME} />} />
    </SentryRoutes>
  );
};

export default AdminRouter;
